import React from 'react';
import { PRODUCT_NAME } from './constants';
const questions = ['What activity should you use?', 'How should you organize the group?', 'What if equipment is limited?', 'What if the space changes?', 'How do you adapt the lesson for different ability levels?'];
export function PainSection() {
  return <section className="bg-brand-cream px-4 py-6 border-b border-brand-line" data-id="element-97" data-mp="2yypl87x8g9ms">
      <div className="max-w-4xl mx-auto" data-id="element-98" data-mp="2l7u64dw54war">
        <div className="bg-white border-l-4 border-brand-green rounded-r-xl p-4 sm:p-5 shadow-sm mb-3" data-id="element-99" data-mp="2l6reu4uworub">
          <h2 className="font-display text-2xl sm:text-3xl text-brand-navy leading-[1.05] mb-2" data-id="element-100" data-mp="2q0dmfim7q5j9">
            What if your next PE lesson was already ready?
          </h2>
          <p className="font-heading font-semibold text-[15px] text-brand-ink leading-snug" data-id="element-101" data-mp="2gaat1hb6ipke">
            You already know how to teach Physical Education.
          </p>
          <p className="font-heading font-semibold text-[15px] text-brand-ink leading-snug mb-2" data-id="element-102" data-mp="278bbmnw95jgx">
            The problem is having to keep planning everything.
          </p>
          <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-0.5 text-sm text-brand-slate font-medium leading-snug list-disc list-inside marker:text-brand-orange mb-2" data-id="element-103" data-mp="3rovfr1f5eqcb">
            {questions.map(q => <li key={q} data-id="element-104" data-mp="gpz86hmypoa">{q}</li>)}
          </ul>
          <p className="text-sm sm:text-base text-brand-slate font-medium leading-snug" data-id="element-105" data-mp="h970udknxol">
            <span className="font-heading font-bold text-brand-navy" data-id="element-106" data-mp="38xb1z5jocmiy">
              {PRODUCT_NAME}
            </span>{' '}
            gives you one organized system to choose, adapt and teach without
            constantly starting from scratch.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-3" data-id="element-107" data-mp="3dv48jzow3ijr">
          <div className="bg-brand-navy text-white rounded-xl p-4 shadow-sm" data-id="element-108" data-mp="3dtj9pxvjldg3">
            <h3 className="font-display text-lg sm:text-xl text-white leading-tight mb-1.5" data-id="element-109" data-mp="2q4gu0vkgxuo8">
              😰 Stop building every PE lesson from zero
            </h3>
            <p className="text-sm text-white/85 font-medium leading-snug mb-1" data-id="element-110" data-mp="p4lpn1guoyx0">
              Searching online gives you ideas. But ideas still need to be
              turned into real lessons.
            </p>
            <p className="text-sm text-white/85 font-medium leading-snug mb-1.5" data-id="element-111" data-mp="yuofwtwl7yrn">
              You need activities that are already structured, clear
              progressions, practical adaptations, group-management tools and
              resources you can actually use.
            </p>
            <p className="font-heading font-bold text-sm text-brand-orange uppercase tracking-wide" data-id="element-112" data-mp="b39bmvl937dr">
              Open the system. Choose what fits. Prepare. Teach.
            </p>
          </div>

          <div className="bg-white border border-brand-line rounded-xl p-4 shadow-sm" data-id="element-113" data-mp="k4zb8opadcmm">
            <h3 className="font-display text-lg sm:text-xl text-brand-navy leading-tight mb-1.5" data-id="element-114" data-mp="1qlb1m3lv9q7n">
              ⏱️ Less searching. Less planning. More teaching.
            </h3>
            <p className="text-sm text-brand-slate font-medium leading-snug mb-1" data-id="element-115" data-mp="25ntaoaqhkn0n">
              Need a complete lesson? It's there. Need a new activity? It's
              there.
            </p>
            <p className="text-sm text-brand-slate font-medium leading-snug mb-1.5" data-id="element-116" data-mp="20r2mt18fwn4o">
              Need a skill progression, circuit, assessment tool or
              no-equipment alternative? It's already organized.
            </p>
            <p className="font-heading font-bold text-sm text-brand-green uppercase tracking-wide" data-id="element-117" data-mp="1mxlcm71n8mrb">
              One practical system for the PE lessons you teach every week.
            </p>
          </div>
        </div>
      </div>
    </section>;
}